import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { firebaseAuth } from "../lib/firebase";
import { getPaymentStatus } from "../services/paymentService";

export const usePaymentPolling = ({
  paymentPending,
  setPaymentPending,
  validStatuses = ["active"],
  onSuccess,
}) => {
  const pollIntervalRef = useRef(null);
  const pollTimeoutRef = useRef(null);
  const onSuccessRef = useRef(onSuccess);
  const validStatusesRef = useRef(validStatuses);

  // Keep refs updated with the latest functions/arrays without triggering re-renders
  useEffect(() => {
    onSuccessRef.current = onSuccess;
    validStatusesRef.current = validStatuses;
  }, [onSuccess, validStatuses]);

  useEffect(() => {
    if (!paymentPending) return;

    const POLL_INTERVAL_MS = 4000;
    const POLL_TIMEOUT_MS = 300000;

    const poll = async () => {
      try {
        const token = await firebaseAuth.currentUser?.getIdToken();
        const { subscription_status } = await getPaymentStatus(token);
        if (validStatusesRef.current.includes(subscription_status)) {
          clearInterval(pollIntervalRef.current);
          clearTimeout(pollTimeoutRef.current);
          setPaymentPending(false);
          if (onSuccessRef.current) onSuccessRef.current();
        }
      } catch (_err) {
        // Ignore transient network errors
      }
    };

    pollIntervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
    
    pollTimeoutRef.current = setTimeout(() => {
      clearInterval(pollIntervalRef.current);
      setPaymentPending(false);
      toast.error(
        "We haven't received payment confirmation yet. Please contact support (+91 8209302759) with your payment ID.",
        { duration: 10000 }
      );
    }, POLL_TIMEOUT_MS);

    return () => {
      clearInterval(pollIntervalRef.current);
      clearTimeout(pollTimeoutRef.current);
    };
  }, [paymentPending, setPaymentPending]);
};
